module.exports = __webpack_public_path__ + "media/level-complete.d7bf2473.mp3";